import api from "./config";
import { API_ENDPOINTS } from "../../utils/constants";
const brandingAPI = {
    GetBranding: async () => {
        var response = await api.get(API_ENDPOINTS.GET_BRANDING);
        return response.data;
    },

};

export default brandingAPI;